<template>
  <div>
    <h1 class="mb-[3.75rem] mt-5 text-center text-[1.5rem] md:mb-20 md:text-[2rem]">
      お問い合わせ
    </h1>
    <p class="mb-4 ml-4 text-center">
      ご質問等は以下フォームよりお気軽にお問い合わせください。
    </p>
    <p class="mb-4 ml-4 text-center">
      <span>お問い合わせの前に「</span>
      <a href="https://support.techacademy.jp/hc/ja">よくあるご質問</a>
      <span>」をご覧ください。</span>
    </p>
    <p />
    <div class="mb-7 flex justify-center">
      <div class="bg-co-gray-200 px-4 py-2 text-co-gray-500 md:w-10/12">
        <h3 class="co-display-13 mb-2 font-bold leading-none">
          お問い合わせの前にご一読ください
        </h3>
        <p class="co-display-14 m-0">
          お電話でのお問い合せはやり取りした内容が記録に残らないため、承っておりません。
          <br>
          お問い合せ送信後、2営業日以内にご返信差し上げます。
          <br>
          営業時間：10:00～18:00（土日・祝祭日を除く）
        </p>
      </div>
    </div>

    <TeContactForm />
  </div>
</template>

<script lang="ts">
import { scriptTagsByConfig } from '~/utility/scriptTags'
import { metaTags } from '~/utility/constants/metaTags'
import TeContactForm from '~/components/Te/TeContact/TeContactForm.vue'

const options = {
  async setup() {
    definePageMeta({
      layout: 'te-side-menu'
    })
  },
  oldHead() {
    const scriptTags = scriptTagsByConfig({
      useCase: 'index',
    })
    return {
      title: 'お問い合わせ |テックアカデミー',
      meta: [
        ...metaTags(
          {
            description:
            'テックアカデミーのお問い合わせフォーム。オンラインブートキャンプについて不明点などがある場合はこのページからご連絡ください。 ',
            ogUrl: '/contact',
            noIndexNofollow: true,
          },
          process.env.host as string
        ),
      ],
      script: scriptTags!.script,
      noscript: scriptTags!.noscript,
    }
  },
  components: {
    TeContactForm,
  },
}

export default defineNuxtComponent(options)
</script>
